function LoadingScreen() {
    return (
        <div className="min-h-screen-safe flex flex-col items-center justify-center bg-white gap-6">
            <svg
                className="animate-spin h-fluid-20 w-fluid-20 text-gray-400"
                viewBox="0 0 24 24"
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                />
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                />
            </svg>
        </div>
    )
}

export default LoadingScreen
